import { useTranslation } from "react-i18next";
import { ConfirmDialog, InlineAlert } from "src/grading/components";

export interface MfaDialogProps {
  open: boolean;
  /** The district's saved identity provider; the attestation is for this provider only (R20). */
  provider: string;
  loading?: boolean;
  /** A refusal, such as `PROVIDER_MISMATCH` copy. */
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Records the district's MFA attestation (FR-039, FR-040): the administrator confirms that the
 * identity provider requires a second sign-in step for district administrators. Only administrators
 * who sign in through that provider skip the console's own step; password sign-ins never do.
 */
export const MfaDialog = ({
  open,
  provider,
  loading = false,
  error,
  onConfirm,
  onClose,
}: MfaDialogProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      testIdPrefix="mfa"
      title={t("district.mfaRecordTitle", { provider })}
      body={t("district.mfaRecordBody", { provider })}
      acknowledgement={t("district.mfaAcknowledge", { provider })}
      confirmLabel={t("district.mfaRecordConfirm")}
      loading={loading}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      {error ? <InlineAlert severity="error">{error}</InlineAlert> : null}
    </ConfirmDialog>
  );
};

export default MfaDialog;
